import gql from 'graphql-tag';

/**
 * Get list of all saved views for a module, including full settings.
 * This allows the client to switch views without additional server queries.
 */
export const userSavedViewsQuery = gql`
  query UserSavedViews($moduleName: String!) {
    userSavedViews(moduleName: $moduleName) {
      views {
        viewName
        updatedAt
        columns {
          header
          binding
          isReadOnly
          visible
          wordWrap
          size
          align
          format
          isContentHtml
          aggregate
        }
        sorting {
          property
          ascending
        }
        groups
        frozenColumns
        filterDefinition
        collapsedGroups
      }
      currentViewName
      maxViews
    }
  }
`;
